import { reactive, ref } from 'vue'

const state = reactive({
  releaseContents: {},
  prSource: null,
  datelineText: null,
  mediaContact: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    isIncludedInDocument: false,
  },
})
const wordCount = ref(0)

const setState = ({
  pressReleaseContent,
  prSource,
  datelineText,
  mediaContact,
}) => {
  state.releaseContents.name = pressReleaseContent?.filename
  wordCount.value = pressReleaseContent?.wordCount ?? 0

  state.prSource = prSource
  state.datelineText = datelineText
  state.mediaContact = mediaContact
}

const clearState = () => {
  state.releaseContents = {}
  state.prSource = null
  state.datelineText = null
  state.mediaContact = {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    isIncludedInDocument: false,
  }
  wordCount.value = 0
}

export { state, wordCount, setState, clearState }
